export default __webpack_public_path__ + "static/media/fondo1.a821033e.png";